import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "text-4xl font-medium capitalize" }
const _hoisted_4 = {
  key: 0,
  class: "pb-8 mt-8"
}
const _hoisted_5 = { class: "text-4xl font-medium capitalize" }
const _hoisted_6 = { class: "flex overflow-x-auto" }
const _hoisted_7 = ["data"]
const _hoisted_8 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_9 = { class: "w-64 px-2 py-2" }
const _hoisted_10 = { class: "px-2 py-2" }
const _hoisted_11 = { class: "px-2 py-2" }
const _hoisted_12 = { class: "px-2 py-2" }
const _hoisted_13 = { class: "px-2 py-2 capitalize" }
const _hoisted_14 = { class: "px-2 py-3 whitespace-nowrap" }
const _hoisted_15 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_16 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_17 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_18 = {
  key: 0,
  class: "px-2 py-2"
}
const _hoisted_19 = {
  key: 1,
  class: "px-2 py-2"
}

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "../TitleHeader.vue";
import EventsTable from "../tables/EventsTable.vue";
import RouterButton from "@/components/RouterButton.vue";
import ResourceCards from "../resources/ResourceCards.vue";
// import TrainingSurveyList from "@/components/surveys/TrainingSurveyList.vue"

import api from "@/api/api";
import { Event, Resource } from "@/types";
import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainerDashboard',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());
const role = userHasRole(user.value.roles, ["l4a-trainer"]) ? "l4a-trainer" : "l4a-trainee";
const hasSmartsurveyAccess = user.value.has_smartsurvey_access;

const resources = ref([] as Resource[]);

async function listResources() {
  resources.value = (
    await api.resources.listResources({
      role: role,
      page: 1,
    })
  ).data.resources;
}

/** Lists events where Trainer is set as trainer/event owner on the event */
const events = ref([] as Event[]);
events.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.events.listEvents({
  page: 1,
  status: "published",
}))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.events;

/** Lists feedback for the current trainer */
const feedback = ref([] as any[]);

if (user.value.has_smartsurvey_access) {
  feedback.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.surveys.getSurveySatifactionForCurrentTrainer())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.eventScores;
}

;(
  ([__temp,__restore] = _withAsyncContext(() => listResources())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('welcome-back'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("training-events")), 1),
        _createVNode(RouterButton, {
          to: { name: 'Training_Events' },
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("see-all-training-events")), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(EventsTable, {
        events: events.value.slice(0, 5)
      }, null, 8, ["events"])
    ]),
    _createVNode(ResourceCards, {
      role: "trainer",
      resources: resources.value.splice(0, 3)
    }, null, 8, ["resources"]),
    (_unref(hasSmartsurveyAccess))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("training-feedback")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", {
              data: feedback.value,
              class: "w-full table-auto mt-2.5"
            }, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_8, [
                  _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("event-name")), 1),
                  _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("feedback-venue")), 1),
                  _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("feedback-delivery")), 1),
                  _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("feedback-recommend")), 1),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("actions")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feedback.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "border-b border-gray-400 divide-x-2 divide-gray-400",
                    key: item.event_id
                  }, [
                    _createElementVNode("td", _hoisted_14, _toDisplayString(item.event_name), 1),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(item.venue_score), 1),
                    _createElementVNode("td", _hoisted_16, _toDisplayString(item.delivery_score), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(item.recommend_score), 1),
                    (item.venue_score === 'n/a' && item.delivery_score === 'n/a' && item.recommend_score === 'n/a')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_18))
                      : (_openBlock(), _createElementBlock("td", _hoisted_19, [
                          _createVNode(_component_router_link, {
                            to: `/dashboard/training-feedback/${item.event_id}`,
                            class: "text-blue"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                  ]))
                }), 128))
              ])
            ], 8, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})